export const COMMON = 'common';
export const SHOPIFY = 'shopify';
